

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["threeDRandom"]?.[key] || fallback;

// === helpers existants utiles ===
function rngPick(arr, fallback) {
  return Array.isArray(arr) && arr?.length
    ? arr[Math.floor(Math.random() * arr?.length)]
    : fallback;
}
function applyCombinationTemplate(template, base, font) {
  const tpl = (template || '{base}:{font}').trim();
  if (!tpl.includes('{font}')) return tpl.replaceAll('{base}', base || '');
  if (!tpl.includes('{base}')) return tpl.replaceAll('{font}', font || '');
  return tpl.replaceAll('{base}', base || '').replaceAll('{font}', font || '');
}
function stripColorName(preset) {
  if (!preset || typeof preset !== 'object') return {};
  const { name, ...rest } = preset;
  return rest;
}

// === filtre IN/EX sur une liste ===
function filterByInEx(list, inArr, exArr) {
  let out = Array.isArray(list) ? [...list] : [];
  const IN = Array.isArray(inArr) && inArr?.length ? new Set(inArr) : null;
  const EX = Array.isArray(exArr) && exArr?.length ? new Set(exArr) : null;
  if (IN) out = out.filter(x => IN.has(x));
  if (EX) out = out.filter(x => !EX.has(x));
  return out;
}

// === modes disponibles (auto/base/font/example) avec exclusions par tableau ===
function resolveVariantModePool(available, variantModes) {
  const clean = (x) => String(x || '').trim();
  const pos = new Set();
  const neg = new Set();
  (Array.isArray(variantModes) ? variantModes : []).forEach(m => {
    const s = clean(m);
    if (!s) return;
    if (s.startsWith('-')) neg.add(s.slice(1));
    else pos.add(s);
  });
  let pool = (pos.size === 0 || pos.has('auto')) ? [...available] : [...available].filter(m => pos.has(m));
  pool = pool.filter(m => !neg.has(m));
  if (!pool?.length) pool = [...available].filter(m => !neg.has(m));
  if (!pool?.length) pool = [...available];
  if (pool?.length > 1 && pool.includes('auto')) pool = pool.filter(m => m !== 'auto');
  return pool;
}

// === pick variant en tenant compte du mode, de IN/EX, et exampleRange ===
function pickVariantWithFilters(variantNode = {}, mode, opts = {}) {
  const bases    = variantNode.bases    || [];
  const fonts    = variantNode.fonts    || [];
  const examples = variantNode.examples || [];
  const template = variantNode.combinationTemplate || '{base}:{font}';

  // lecture des filtres du mode courant
  const IN = opts.in;
  const EX = opts.ex;

  if (mode === 'base') {
    const pool = filterByInEx(bases, IN, EX);
    const b = rngPick(pool, rngPick(bases, 'grey3D'));
    return b || 'grey3D';
  }

  if (mode === 'font') {
    const pool = filterByInEx(fonts, IN, EX);
    const f = rngPick(pool, rngPick(fonts, 'playfairDisplay'));
    return f || 'playfairDisplay';
  }

  if (mode === 'example') {
    // range optionnel
    const { exampleRange } = opts;
    let exList = [...examples];
    if (exampleRange) {
      let s, e;
      if (Array.isArray(exampleRange)) [s, e] = exampleRange;
      else ({ start0: s, end0: e } = exampleRange);
      s = Math.max(0, Math.min(s ?? 0, exList?.length - 1));
      e = Math.max(s, Math.min(e ?? (exList?.length - 1), exList?.length - 1));
      exList = exList.slice(s, e + 1);
    }
    exList = filterByInEx(exList, IN, EX);
    const ex = rngPick(exList, null);
    if (ex) return ex;
    // fallback: fabriquer un combo base:font
    const b = rngPick(filterByInEx(bases, IN, EX), rngPick(bases, 'grey3D')) || 'grey3D';
    const f = rngPick(filterByInEx(fonts, IN, EX), rngPick(fonts, 'playfairDisplay')) || 'playfairDisplay';
    return applyCombinationTemplate(template, b, f);
  }

  // sécurité: auto-fallback combo
  const b = rngPick(bases, 'grey3D');
  const f = rngPick(fonts, 'playfairDisplay');
  return applyCombinationTemplate(template, b, f);
}

// === generateThreeDOptions avec variantModes[] + IN/EX contextuels ===
export function generateThreeDOptions(colorMatric, componentThreeDText, n = 3, opts = {}) {
  __setElakayInfoSource(opts.infoSource);
  const count = Math.max(3, Number.isFinite(n) ? Math.floor(n) : 3);
  const variantNode = componentThreeDText?.variant || {};
  const availModes = [];
  if (variantNode.bases?.length)   availModes.push('base');
  if (variantNode.fonts?.length)   availModes.push('font');
  if (variantNode.examples?.length) availModes.push('example');
  const modePool = resolveVariantModePool(["auto", "base", "font", "example"], opts.variantModes);

  const out = [];
  for (let i = 0; i < count; i++) {
    // si modePool == ['auto'] → on choisit un mode réel dispo
    let chosenMode = rngPick(modePool, 'auto');
    if (chosenMode === 'auto') {
      chosenMode = rngPick(availModes?.length ? availModes : ['example'], 'example');
    }

    const text = rngPick(componentThreeDText?.text, 'Lakay Yvox');
    const variant = pickVariantWithFilters(variantNode, chosenMode, opts);
    const placement = rngPick(componentThreeDText?.placement?.presets, 'inline');

    const colorPreset = rngPick(colorMatric, null) || {};
    const colors = stripColorName(colorPreset);

    out.push({
      text,
      variant,       // "base" | "font" | "base:font" selon chosenMode
      placement,
      colors,
      meta: { colorName: colorPreset?.name, chosenMode, variantModes: opts.variantModes || ['auto'] }
    });
  }
  return out;
}


// ===== 2) Sélectionne une entrée par nombre y (index circulaire) =====
/**
 * @param {Array} options - array renvoyé par generateThreeDOptions
 * @param {number} y - nombre (entier) pour choisir l’élément (modulo longueur)
 * @returns {Object} - une seule configuration choisie
 */
export function selectThreeDByY(options, y) {
  if (!Array.isArray(options) || options?.length === 0) {
    throw new Error('options est vide.');
  }
  const idx = ((Math.trunc(y) % options?.length) + options?.length) % options?.length;
  return options[idx];
}

/* ==========================
Voici un **guide d’utilisation complet** pour les fonctions utilitaires **`generateThreeDOptions`** et **`selectThreeDByY`**. Il couvre l’objectif, l’API exacte, les options (dont `variantMode` et `exampleRange`), le format de retour, les exemples, les cas limites et des types TypeScript.

---

Voici un **guide complet et à jour** pour utiliser **`generateThreeDOptions`** et **`selectThreeDByY`**, avec les nouveaux contrôles : `variantModes` (inclure/exclure des modes), filtres `in`/`ex` par mode, et `exampleRange`.

---

# 1) À quoi servent ces fonctions ?

* **`generateThreeDOptions(colorMatric, componentThreeDText, n=3, opts)`**
  Génère **au moins `n` propositions** prêtes pour `<ThreeDText />` : `text`, `variant`, `placement`, `colors`.
  Le **variant** peut sortir :

  * d’une **base** (ex: `"chromeBevel"`)
  * d’une **font** (ex: `"oswald"`)
  * d’un **example** (ex: `"chromeBevel:playfairDisplay"`)
  * en **auto** (tirage au hasard parmi les modes autorisés & disponibles).

* **`selectThreeDByY(options, y)`**
  Choisit **une seule** entrée depuis la liste produite par `generateThreeDOptions`.
  L’index est **circulaire** (modulo la longueur), donc `y` peut être négatif ou très grand.

---

# 2) Prérequis des matrices (format minimal)

```json
// componentThreeDText (extrait)
{
  "text": ["ELAKAY", "WELCOME.;TO.;ELAKAY", "FLASH SALE"],
  "variant": {
    "bases": ["grey3D", "neonGlow", "chromeBevel", "gradientOutline", "glassy"],
    "fonts": ["playfairDisplay", "oswald", "bebasNeue", "prata"],
    "examples": ["chromeBevel:playfairDisplay", "neonGlow:oswald"],
    "combinationTemplate": "{base}:{font}"
  },
  "placement": { "presets": ["inline", "center", "topCenter", "bottomCenter", "centerRight", "centerLeft"] }
}
```

```json
// colorMatric (extrait)
[
  { "name": "Sunset", "text": "#fff", "gradientStart": "#ff8a00", "gradientEnd": "#e52e71", "outline": "#141414" },
  { "name": "Neon Blue", "text": "#43c6ff", "glow": "rgba(67,198,255,.85)", "shadow": "rgba(0,0,0,.38)" }
]
```

> Clés de couleurs supportées par `<ThreeDText />` :
> `text`, `stroke`, `outline`, `shadow`, `reflection`, `gradientStart`, `gradientEnd`, `glow`.

---

# 3) API détaillée

## 3.1 `generateThreeDOptions(colorMatric, componentThreeDText, n?, opts?)`

* **Params**

  * `colorMatric: Array<ColorPreset>` — presets de couleurs (peuvent inclure `name`)
  * `componentThreeDText: ThreeDMatrix` — textes, variantes (bases/fonts/examples), placements
  * `n: number` — combien d’options (min forcé à **3**)
  * `opts: object` :

    * `variantModes?: string[]`
      Contrôle **les modes autorisés** (et exclus) pour le tirage :

      * valeurs positives : `"auto"|"base"|"font"|"example"` → **inclusion**
      * valeurs négatives : `"-base"`, `"-font"`, `"-example"` → **exclusion**
      * exemples :

        * `["auto"]` → auto normal (parmi tous les modes dispo)
        * `["auto","-font"]` → auto mais **jamais** le mode `font`
        * `["base","example"]` → tirages **uniquement** en base ou example (jamais font)
        * `["-example"]` → exclure example (pool = base|font)
    * `in?: string[]` — **liste blanche** au niveau du **mode concret**

      * mode `base` → `in = ["chromeBevel","grey3D"]`
      * mode `font` → `in = ["oswald","bebasNeue"]`
      * mode `example` → `in = ["grey3D:playfairDisplay","glassy:prata"]`
    * `ex?: string[]` — **liste noire** au niveau du **mode concret**
    * `exampleRange?: {start0?, end0?} | [start0, end0]`
      Limite l’intervalle **0-based** dans `variant.examples` quand le mode final est `example`.

* **Retour**: `Array<ThreeDOption>`
  Chaque option :

  ```js
  {
    text: string,
    variant: string,       // ex: "chromeBevel" | "oswald" | "chromeBevel:playfairDisplay"
    placement: string,     // ex: "center"
    colors: object,        // clés de couleurs (sans 'name')
    meta: {
      colorName?: string,  // ex: "Sunset"
      chosenMode: 'base'|'font'|'example', // mode réel tiré (auto résolu)
      variantModes: string[] // ce que vous avez passé en opts
    }
  }
  ```

## 3.2 `selectThreeDByY(options, y)`

* `options: ThreeDOption[]` — liste produite par `generateThreeDOptions`
* `y: number` — entier (positif, négatif, grand…) → index circulaire
* **Retour**: `ThreeDOption` — une seule entrée

---

# 4) Comportement des modes & filtres

* **`variantModes`** décide **où** on a le droit de piocher.

  * `["auto"]` → choisir un **mode concret** au hasard parmi **ceux disponibles** (base/font/example).
  * `["auto", "-font"]` → comme auto mais **jamais** font.
  * `["base","example"]` → le mode sera **base** ou **example** (jamais font).

* Une fois le **mode concret** choisi :

  * **`in`** / **`ex`** s’appliquent **sur la liste correspondante** (bases, fonts, ou examples).
  * **`exampleRange`** découpe le tableau `variant.examples` **avant** `in/ex`.

* **Fallbacks intelligents** :

  * Si `example` n’a rien (après range + in/ex), on recompose un **combo** via `combinationTemplate` et un tirage dans `bases`/`fonts`.
  * Si `variantModes` vide/contradictoire, on revient aux **modes disponibles**.

---

# 5) Exemples pratiques

## 5.1 Auto normal (tout permis), choisir via `y`

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 5, {
  variantModes: ['auto']
});
const pick = selectThreeDByY(options, 13);

<ThreeDText text={pick.text} variant={pick.variant} colors={pick.colors} pos="c" />;
```

## 5.2 Auto **sans fonts** (jamais de `font` seule)

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 5, {
  variantModes: ['auto', '-font']
});
const pick = selectThreeDByY(options, 7);
```

## 5.3 **Base** uniquement avec liste blanche/noire

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 4, {
  variantModes: ['base'],
  in: ['chromeBevel', 'grey3D'], // autorisées
  ex: ['grey3D']                  // mais on exclut grey3D → il reste chromeBevel
});
const pick = selectThreeDByY(options, 1);
// pick.variant === "chromeBevel"
```

## 5.4 **Font** uniquement (polices décoratives)

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 3, {
  variantModes: ['font'],
  in: ['oswald', 'bebasNeue', 'playfairDisplay'],
  ex: ['playfairDisplay']
});
const pick = selectThreeDByY(options, 0);
// pick.variant => "oswald" ou "bebasNeue"
```

## 5.5 **Example** avec `in`/`ex` + `exampleRange`

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 6, {
  variantModes: ['example'],
  in : ["grey3D:playfairDisplay","grey3D:greatVibes","grey3D:pacifico"],
  ex : ["glassy:playfairDisplay","glassy:greatVibes","glassy:pacifico"],
  exampleRange: { start0: 0, end0: 19 } // par ex. le bloc des 20 premières combinaisons
});
const pick = selectThreeDByY(options, 3);
```

## 5.6 **Base ou Example** (jamais Font)

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 6, {
  variantModes: ['base', 'example']
});
const pick = selectThreeDByY(options, 2);
```

## 5.7 Déterministe par minute (sans state)

```js
const y = new Date().getMinutes();
const options = generateThreeDOptions(colorMatric, componentThreeDText, 5, {
  variantModes: ['auto','-font']
});
const pick = selectThreeDByY(options, y);
```

## 5.8 Grille 6 cartes (un pick par index)

```jsx
function Card({ idx }) {
  const options = generateThreeDOptions(colorMatric, componentThreeDText, 6, {
    variantModes: ['auto']
  });
  const pick = selectThreeDByY(options, idx);
  return (
    <div className="relative h-40 border rounded-xl overflow-hidden">
      <ThreeDText text={pick.text} variant={pick.variant} colors={pick.colors} pos="c" size={{ sm:28, md:40, lg:64 }} />
    </div>
  );
}
```

---

# 6) Cas limites & conseils

* `n < 3` → forcé à **3**.
* `options` vide → `selectThreeDByY` lève une erreur.
* `variantModes` contradictoire (ex. `["base","-base"]`) → le code retombe sur un pool valide (disponibles).
* `exampleRange` hors bornes → corrigé automatiquement à l’intérieur des limites.
* `in` + `ex` peuvent se neutraliser : si tout est exclu, un **fallback** ressortira (ex. combo via template).

---

# 7) Types TypeScript (optionnel)

```ts
type ColorPreset = {
  name?: string;
  text?: string; stroke?: string; outline?: string; shadow?: string;
  reflection?: string; gradientStart?: string; gradientEnd?: string; glow?: string;
};

type VariantMatrix = {
  bases?: string[];
  fonts?: string[];
  examples?: string[];
  combinationTemplate?: string; // "{base}:{font}"
};

type ThreeDMatrix = {
  text?: string[];
  variant?: VariantMatrix;
  placement?: { presets?: string[] };
};

type GenerateOpts = {
  variantModes?: string[]; // ["auto","-font"] | ["base","example"] | ["example"] ...
  in?: string[];           // liste blanche contextuelle au mode concret
  ex?: string[];           // liste noire contextuelle au mode concret
  exampleRange?: { start0?: number; end0?: number } | [number, number];
};

type ThreeDOption = {
  text: string;
  variant: string;
  placement: string;
  colors: Omit<ColorPreset,'name'>;
  meta: { colorName?: string; chosenMode: 'base'|'font'|'example'; variantModes: string[] };
};

declare function generateThreeDOptions(
  colorMatric: ColorPreset[],
  componentThreeDText: ThreeDMatrix,
  n?: number,
  opts?: GenerateOpts
): ThreeDOption[];

declare function selectThreeDByY<T = ThreeDOption>(options: T[], y: number): T;
```

---

# 8) Snippet minimal (copier/coller)

```js
const options = generateThreeDOptions(colorMatric, componentThreeDText, 5, {
  variantModes: ['auto', '-font'],   // auto, mais jamais font
  // in: ['chromeBevel','grey3D'],   // si le mode tiré est base → restreint à ces bases
  // ex: ['grey3D'],                 // exclure ceci dans le mode tiré
  // exampleRange: [0, 59]           // si le mode tiré est example → limiter la plage
});
const pick = selectThreeDByY(options, 7);

<ThreeDText
  text={pick.text}
  variant={pick.variant}
  placement={pick.placement}
  colors={pick.colors}
/>;
```

---

Si tu veux, je peux te fournir un **README.md** prêt à mettre dans ton repo, ou un **Storybook** avec des controls (`n`, `y`, `variantModes`, `in`, `ex`, `exampleRange`) et un **live preview**.

---

Tu veux que je **génère un README.md** structuré avec ces sections, ou que j’ajoute un **Storybook** avec des **controls** (`n`, `y`, `variantMode`, `exampleRange`) et un **preview live** ?
Voici le **repérage par base** dans la liste plate des 200 combinaisons (`BASE:FONT`) triées par base, puis par les 20 polices.
Chaque base occupe **20 entrées** successives.

### Tableau (index 0-based et 1-based)

| Base            | 0-based start | 0-based end | 1-based start | 1-based end | Count |
| --------------- | ------------: | ----------: | ------------: | ----------: | ----: |
| grey3D          |             0 |          19 |             1 |          20 |    20 |
| orange3D        |            20 |          39 |            21 |          40 |    20 |
| yellowOutline   |            40 |          59 |            41 |          60 |    20 |
| redCartoon      |            60 |          79 |            61 |          80 |    20 |
| neonGlow        |            80 |          99 |            81 |         100 |    20 |
| chromeBevel     |           100 |         119 |           101 |         120 |    20 |
| bubbleGum       |           120 |         139 |           121 |         140 |    20 |
| gradientOutline |           140 |         159 |           141 |         160 |    20 |
| halftoneComic   |           160 |         179 |           161 |         180 |    20 |
| glassy          |           180 |         199 |           181 |         200 |    20 |

### Version JSON prête à utiliser

```json
[
  { "base": "grey3D",         "start0": 0,   "end0": 19,  "start1": 1,   "end1": 20,  "count": 20 },
  { "base": "orange3D",       "start0": 20,  "end0": 39,  "start1": 21,  "end1": 40,  "count": 20 },
  { "base": "yellowOutline",  "start0": 40,  "end0": 59,  "start1": 41,  "end1": 60,  "count": 20 },
  { "base": "redCartoon",     "start0": 60,  "end0": 79,  "start1": 61,  "end1": 80,  "count": 20 },
  { "base": "neonGlow",       "start0": 80,  "end0": 99,  "start1": 81,  "end1": 100, "count": 20 },
  { "base": "chromeBevel",    "start0": 100, "end0": 119, "start1": 101, "end1": 120, "count": 20 },
  { "base": "bubbleGum",      "start0": 120, "end0": 139, "start1": 121, "end1": 140, "count": 20 },
  { "base": "gradientOutline","start0": 140, "end0": 159, "start1": 141, "end1": 160, "count": 20 },
  { "base": "halftoneComic",  "start0": 160, "end0": 179, "start1": 161, "end1": 180, "count": 20 },
  { "base": "glassy",         "start0": 180, "end0": 199, "start1": 181, "end1": 200, "count": 20 }
]
```

Si tu veux, je peux aussi te générer une petite fonction qui, donnée une **base** et un **index de police [0..19]**, renvoie l’index global (et inversement).

 * ========================== */